<template>
    <div class="screenForPlayer">
        <div class="headerPlayer " >
            <div style="float:left;;margin-top: 5px">
                <s-button icon="times-circle" label="" theme="is-warning " @onclick="$router.go(-1)"/>
            </div>
             <div class="numero" v-if="numeroJoueurFormeAlea>=0">{{numeroJoueurFormeAlea + 1}}</div>
            <div class="detailHeader" v-if="tournoi" >
                <div v-if="tournoi"> Concours : {{formatDate(tournoi.date)}} à {{tournoi.heure}} </div>
                <s-fil :options="tournoi.options" />
                <div v-if="joueurClub">joueur : {{joueurClub.pseudo}} </div>
                <div v-if="equipe">{{titlePartie}}</div>
            </div>
           
        </div>
        <preinscription 
            v-if="!joueur"
            :club="club"
            :tournoi="tournoi"
            :joueur="joueurClub"
        />
        <tournoiWaiting 
            v-if="joueur && tournoi && tournoi.state=='INSCRIPTION'"
            :club="club"
            :tournoi="tournoi"
            :joueur="joueur"
            :numeroJoueur="numeroJoueur"
        />
        <div v-if="club!=null && tournoi!=null && joueur!=null" style="height:100%">
         <inprogress v-if="tournoi.state=='INPROGRESS'"
            :club="club"
            :tournoi="tournoi"
            :joueur="joueur"
            :equipe="equipe"
            :numeroJoueur="numeroJoueur"
           
        />
        </div>
        
    </div>
</template>
<style scoped>
    
    .numero {
        float:right;
        border-radius: 20px;
        font-size: 20px;
        color: white;
        margin-right: 20px;
        margin-top: 10px;
        background-color: #68CC77;
        padding-left: auto;
        padding-right: auto;
        width: 40px;
    }
    @media screen and (max-width: 420px) {
        .screenForPlayer {
            width: 100%;
            margin-left: auto;
            margin-right: auto;
            margin-top:0px;
            text-align: center;
           
        }
        
        .sinscription {
            padding: 10px;
            color: black;
        }
        .headerPlayer {
            background-color: var(--bluebg);
            color: white;
            padding-top: 2px;
            position: fixed;
            padding-left: 5px;
            width: 100%;
            font-weight: bold;
            font-size: 16px;
            
            z-index: 30;
        } 
        .detailHeader {
            font-size: 13px;text-align:left;margin-left: 60px
        }
    }
    @media screen and (min-width: 420px) {
        .detailHeader {
            font-size: 20px;text-align:left;margin-left: 60px
        }
        .headerPlayer {
            background-color: var(--bluebg);
            color: white;
            padding-top: 2px;
            
        }
        .headerPlayer {
            border-radius: 20px 20px 0px 0px;
            font-weight: bold;
            font-size: 18px;
         }
        .screenForPlayer {
            text-align: center;
            width: 100%;
            max-width: 700px;
            margin-left: auto;
            margin-right: auto;
            margin-top: 30px;
            border: thin solid var(--bluebg);
            border-radius: 20px 20px 20px 20px;
            height: 660px;
        }
        .sinscription {
            padding: 10px;
            color: black;
        }
    }
</style>
<script>
    import club            from '@/firebase/club'
    import tournoi_fct     from '@/firebase/tournoi'
    import firebase_api    from '@/firebase/firebase_api'
    import preinscription  from '@/views/myTournoi/preinscription.vue'    
    import tournoiWaiting  from '@/views/myTournoi/tournoiWaiting.vue'    
    import inprogress  from '@/views/myTournoi/inprogress.vue'  
   
    export default {
        components: {
            preinscription,
            tournoiWaiting,
            inprogress
        },
        computed: {
            titlePartie: {
             get() {
                  if (typeof(this.tournoi)!="undefined" && this.tournoi!=null) {
                 if (this.tournoi.options.competition == 3) {
                    if (this.indexPartie==0)
                        return "Poule - Partie " + (this.indexPartie+1)
                    if (this.indexPartie==1)
                        return "Poule - Partie " + (this.indexPartie+1)
                    if (this.indexPartie==2)
                        return "Barrage"
                    if (this.indexPartie>2)
                        return "Eliminatoire " + (this.indexPartie+1)
                 }
                 else 
                    return "Partie " + (this.indexPartie+1)
             }
             }
         },
            numeroJoueurFormeAlea() {
                
                if (typeof(this.tournoi)!="undefined" && this.tournoi!=null) {
                    if (typeof(this.tournoi.joueurs)!="undefined") {     
                       
                        if (this.tournoi.options.mode=='ALEA') {
                            // nous sommes en forme
                            var numeroJoueur = this.tournoi.joueurs.findIndex(joueur=>joueur.id === this.idJoueur);
                             return numeroJoueur;
                        }
                        else {
                            
                            var numeroJoueur = this.tournoi.joueurs.findIndex(joueur=>joueur.id === this.idJoueur);
                        
                            if (numeroJoueur!=-1) {
                               
                                if (this.tournoi.joueurs[numeroJoueur].meneur == true) {
                                    return numeroJoueur;
                                }
                                else {
                                  
                                    var numeroEquipe = this.tournoi.joueurs.findIndex(joueur=>joueur.coequipier1 === this.idJoueur);
                                   
                                    if (numeroEquipe!=-1) {
                                        
                                        return numeroEquipe;
                                    }
                                    else {
                                        numeroEquipe = this.tournoi.joueurs.findIndex(joueur=>joueur.coequipier2 === this.idJoueur);
                                        return numeroEquipe;
                                       
                                    }
                                }
                            }
                            else
                                return -1;
                        }
                    }
                }
            }
        },
        watch: {
            tournoi() {
                if (typeof(this.tournoi)!="undefined") {
                    if (typeof(this.tournoi.joueurs)!="undefined") {
                    this.numeroJoueur = this.tournoi.joueurs.findIndex(joueur=>joueur.id === this.idJoueur);
                
                    if (this.numeroJoueur != -1) {
                        this.joueur = this.tournoi.joueurs[this.numeroJoueur]
                    //   this.initEquipe();
                    }
                    else {
                        this.numeroJoueur = null;
                        this.joueur = null;
                    }
                    }
                }
            }
        },
        data() {
            return {
                tournoi: null,
                equipe: null,
                club: null,
                idClub: null,
                idTournoi: null,
                idJoueur: null,
                numeroJoueur: null,
                indexPartie: 0,
                joueur: null,
                joueurClub: null,
                modalPoule: false
            }
        },
        methods: {
            formatDate(date) {
                var options = {weekday: "long", year: "numeric", month: "long", day: "numeric"};
                return (new Date(date)).toLocaleString("fr-Fr",options);
            },
        },
        mounted() {
            this.idClub = this.$route.params.idClub;
            this.idTournoi = this.$route.params.idTournoi;
            firebase_api.api.getDb().collection("club").doc(this.idClub).get().then(club=>{
                this.club = club.data();
            })
            var user = this.$store.getters.getUser;
            var indexJoueurInUser = user.clubs.findIndex(elt=>elt.idClub === this.idClub);
            if (indexJoueurInUser!=-1)
                this.idJoueur = user.clubs[indexJoueurInUser].idJoueur;
        
            this.$bind("joueurClub", firebase_api.api.getDb().collection("club").doc(this.idClub).collection("joueurs").doc(this.idJoueur))
            this.$bind("tournoi", firebase_api.api.getDb().collection("club").doc(this.idClub).collection("tournois").doc(this.idTournoi)).then(tournoiParam=>{
                
                this.numeroJoueur = tournoiParam.joueurs.findIndex(joueur=>joueur.id === this.idJoueur);
            
                if (this.numeroJoueur != -1) {
                    this.joueur = tournoiParam.joueurs[this.numeroJoueur];
                    
                //   this.initEquipe();
                }
            })
        
    }
    }
</script>